<div
    *ngIf="isOpen"
    class="convocation-drawer-backdrop"
    (click)="onClose()"
    aria-label="Chiudi"
>
    <div
        class="convocation-drawer-panel"
        (click)="$event.stopPropagation()"
        role="dialog"
        [attr.aria-label]="drawerTitle"
    >
        <header class="!flex !items-center !justify-between !border-b !border-border !px-5 !py-4">
            <div>
                <p class="!mb-0 !text-xs !font-semibold !uppercase !tracking-wide !text-subtle">
                    {{ isEditMode ? 'Modifica' : 'Nuova' }}
                </p>
                <h2 class="!mb-0 !text-lg !font-bold !text-strong">{{ drawerTitle }}</h2>
            </div>
            <button
                type="button"
                class="btn-close"
                aria-label="Chiudi"
                (click)="onClose()"
            ></button>
        </header>

        <div class="convocation-drawer-body">
            <form #convForm="ngForm" (ngSubmit)="onSave()" autocomplete="off">

                <section class="!mb-7">
                    <p class="!mb-3 !text-xs !font-bold !uppercase !tracking-widest !text-subtle">
                        Informazioni generali
                    </p>

                    <div class="!mb-4">
                        <label class="!mb-1 !block !text-sm !font-semibold !text-strong">Titolo *</label>
                        <input
                            class="form-control"
                            type="text"
                            [(ngModel)]="form.title"
                            name="title"
                            placeholder="Es. Allenamento tecnico portieri"
                            required
                        />
                    </div>

                    <div class="!mb-4 !grid !grid-cols-2 !gap-3">
                        <div>
                            <label class="!mb-1 !block !text-sm !font-semibold !text-strong">Categoria</label>
                            <p *ngIf="categoriesLoading" class="!mb-0 !text-xs !text-subtle">Caricamento categorie…</p>
                            <select
                                *ngIf="!categoriesLoading"
                                class="form-control form-select"
                                [(ngModel)]="form.categoryId"
                                name="categoryId"
                                (ngModelChange)="onCategoryChange()"
                            >
                                <option value="">— Seleziona categoria —</option>
                                <option *ngFor="let opt of categorySelectOptions" [value]="opt.id">{{ opt.label }}</option>
                            </select>
                            <p *ngIf="!categoriesLoading && !companyId" class="!mb-0 !mt-1 !text-xs !text-amber-700">
                                Società non disponibile: impossibile caricare categorie e convocati.
                            </p>
                        </div>
                        <div>
                            <label class="!mb-1 !block !text-sm !font-semibold !text-strong">Stato *</label>
                            <select
                                class="form-control form-select"
                                [(ngModel)]="form.status"
                                name="status"
                                required
                            >
                                <option *ngFor="let s of statusOptions" [value]="s">{{ s }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="!mb-4">
                        <span class="!mb-1 !block !text-sm !font-semibold !text-strong">Data e ora *</span>
                        <div class="!grid !grid-cols-[minmax(0,1fr)_8rem] !gap-3">
                            <div class="!relative">
                                <i class="bi bi-calendar3 !pointer-events-none !absolute !left-3 !top-1/2 !-translate-y-1/2 !text-slate-400" aria-hidden="true"></i>
                                <input class="form-control !pl-9" type="date" name="datePart" aria-label="Data"
                                       [(ngModel)]="datePart" required />
                            </div>
                            <div class="!relative">
                                <i class="bi bi-clock !pointer-events-none !absolute !left-3 !top-1/2 !-translate-y-1/2 !text-slate-400" aria-hidden="true"></i>
                                <input class="form-control !pl-9" type="time" name="timePart" aria-label="Ora" step="300"
                                       [(ngModel)]="timePart" required />
                            </div>
                        </div>
                        <div class="!mt-2 !flex !flex-wrap !gap-1.5">
                            <button *ngFor="let day of dayPresets" type="button"
                                    class="!rounded-full !border !border-solid !px-2.5 !py-1 !text-xs !font-semibold !transition"
                                    [ngClass]="datePart === day.date ? '!border-primary !bg-primary-soft !text-primary' : '!border-slate-200 !bg-white !text-slate-600 hover:!border-slate-300'"
                                    (click)="datePart = day.date">{{ day.label }}</button>
                            <span class="!mx-1 !self-center !text-slate-300" aria-hidden="true">|</span>
                            <button *ngFor="let time of timePresets" type="button"
                                    class="!rounded-full !border !border-solid !px-2.5 !py-1 !text-xs !font-semibold !tabular-nums !transition"
                                    [ngClass]="timePart === time ? '!border-primary !bg-primary-soft !text-primary' : '!border-slate-200 !bg-white !text-slate-600 hover:!border-slate-300'"
                                    (click)="timePart = time">{{ time }}</button>
                        </div>
                        <p *ngIf="dateSummary" class="!mb-0 !mt-2 !flex !items-center !gap-1.5 !text-xs"
                           [ngClass]="isDateInPast ? '!text-amber-700' : '!text-subtle'">
                            <i class="bi" [ngClass]="isDateInPast ? 'bi-exclamation-triangle' : 'bi-calendar-check'" aria-hidden="true"></i>
                            {{ dateSummary }}<ng-container *ngIf="isDateInPast"> · data già passata</ng-container>
                        </p>
                    </div>

                    <div>
                        <label class="!mb-1 !block !text-sm !font-semibold !text-strong">Note / Dettagli</label>
                        <textarea
                            class="form-control"
                            rows="3"
                            [(ngModel)]="form.description"
                            name="description"
                            placeholder="Istruzioni per i convocati, cosa portare…"
                        ></textarea>
                    </div>
                </section>

                <section class="!mb-7">
                    <p class="!mb-3 !text-xs !font-bold !uppercase !tracking-widest !text-subtle">
                        Luogo dell'evento
                    </p>

                    <div class="!mb-4">
                        <ui-address-search
                            inputId="convocation-address"
                            name="address"
                            label="Cerca indirizzo o impianto *"
                            placeholder="Es. Centro sportivo, Via Roma 10, Monza"
                            hint="Scegli un suggerimento: indirizzo, città, provincia e link mappa si compilano da soli."
                            [required]="true"
                            [value]="form.address || ''"
                            (valueChange)="form.address = $event; onPlaceTextChange()"
                            (selected)="onAddressSelected($event)">
                        </ui-address-search>
                    </div>

                    <div class="!mb-4">
                        <label class="!mb-1 !block !text-sm !font-semibold !text-strong" for="convocation-location">Nome del luogo *</label>
                        <input
                            id="convocation-location"
                            class="form-control"
                            type="text"
                            [(ngModel)]="form.location"
                            name="location"
                            placeholder="Es. Campo Sportivo Comunale"
                            required
                        />
                    </div>

                    <div class="!mb-4 !grid !grid-cols-[1fr_5rem] !gap-3">
                        <div>
                            <label class="!mb-1 !block !text-sm !font-semibold !text-strong" for="convocation-city">Città *</label>
                            <input
                                id="convocation-city"
                                class="form-control"
                                type="text"
                                [(ngModel)]="form.city"
                                (ngModelChange)="onPlaceTextChange()"
                                (blur)="refreshMapPreview()"
                                name="city"
                                placeholder="Milano"
                                required
                            />
                        </div>
                        <div>
                            <label class="!mb-1 !block !text-sm !font-semibold !text-strong" for="convocation-province">Prov.</label>
                            <input
                                id="convocation-province"
                                class="form-control !uppercase"
                                type="text"
                                [(ngModel)]="form.province"
                                (ngModelChange)="onPlaceTextChange()"
                                (blur)="refreshMapPreview()"
                                name="province"
                                placeholder="MI"
                                maxlength="2"
                            />
                        </div>
                    </div>

                    <!-- Map preview -->
                    <div class="!mb-4 !overflow-hidden !rounded-xl !border !border-solid !border-slate-200 !bg-slate-50">
                        <iframe *ngIf="mapPreviewUrl; else noMap"
                                class="!block !h-48 !w-full !border-0"
                                [src]="mapPreviewUrl"
                                title="Anteprima mappa del luogo"
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                        <ng-template #noMap>
                            <div class="!flex !h-28 !flex-col !items-center !justify-center !gap-1 !text-center !text-xs !text-slate-400">
                                <i class="bi bi-map !text-2xl" aria-hidden="true"></i>
                                Cerca un indirizzo per vedere l'anteprima della mappa.
                            </div>
                        </ng-template>
                        <div *ngIf="mapPreviewUrl" class="!flex !items-center !justify-between !gap-2 !border-0 !border-t !border-solid !border-slate-200 !bg-white !px-3 !py-2">
                            <a class="!inline-flex !items-center !gap-1 !text-xs !font-semibold !text-primary !no-underline hover:!underline"
                               [href]="mapsSearchLink" target="_blank" rel="noopener">
                                Apri in Google Maps <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i>
                            </a>
                            <button *ngIf="form.linkPosition !== mapsSearchLink" type="button"
                                    class="!border-0 !bg-transparent !p-0 !text-xs !font-semibold !text-slate-500 hover:!text-primary"
                                    (click)="useMapsLink()">
                                Usa come link della convocazione
                            </button>
                        </div>
                    </div>

                    <div>
                        <label class="!mb-1 !block !text-sm !font-semibold !text-strong" for="convocation-link">Link mappa / indicazioni</label>
                        <input
                            id="convocation-link"
                            class="form-control"
                            type="text"
                            [(ngModel)]="form.linkPosition"
                            name="linkPosition"
                            placeholder="https://maps.google.com/… oppure testo libero"
                        />
                        <p class="!mb-0 !mt-1 !text-xs !text-subtle">
                            Si compila scegliendo un indirizzo; puoi incollare un altro link o scrivere indicazioni.
                        </p>
                    </div>
                </section>

                <section class="!mb-2">
                    <div class="!mb-3 !flex !items-center !justify-between">
                        <p class="!mb-0 !text-xs !font-bold !uppercase !tracking-widest !text-subtle">
                            Convocati
                        </p>
                        <span class="!rounded-full !bg-zinc-100 !px-2.5 !py-0.5 !text-xs !font-bold !text-zinc-600">
                            {{ invitedUsers.length }}
                        </span>
                    </div>

                    <p *ngIf="!form.categoryId" class="!mb-3 !text-sm !text-subtle">
                        Scegli prima la <strong>categoria</strong> sopra: compariranno gli atleti iscritti.
                    </p>

                    <ui-table
                        #athletesTable
                        *ngIf="form.categoryId"
                        class="convocation-athletes-table no-box-model"
                        [allowSearch]="true"
                    >
                        <ng-template #customHeader>
                            <tr>
                                <th class="text-center" style="width: 3rem"></th>
                                <th>Atleta / Recapiti</th>
                                <th>Tesseramento</th>
                                <th *ngIf="primaryDocumentExists">Scadenza doc.</th>
                            </tr>
                        </ng-template>

                        <ng-template #customRow let-row="row">
                            <tr
                                [class.convocation-row-selected]="isInvited(row.athlete?.id)"
                            >
                                <td class="text-center align-middle">
                                    <input
                                        type="checkbox"
                                        class="form-check-input !m-0"
                                        [checked]="isInvited(row.athlete?.id)"
                                        (change)="toggleInvited(row)"
                                        [attr.aria-label]="'Convoca ' + row.athlete?.firstName + ' ' + row.athlete?.lastName"
                                    />
                                </td>
                                <td>
                                    <div class="fw-bold text-dark">
                                        {{ row.athlete.firstName }} {{ row.athlete.lastName }}
                                    </div>
                                    <div class="small text-muted">
                                        {{ row.athlete.fiscalCode }}
                                    </div>
                                    <div class="small mt-1">
                                        <i class="bi bi-telephone me-1"></i>{{ row.athlete.phone }}
                                        <span class="mx-1">|</span>
                                        <i class="bi bi-envelope me-1"></i>{{ row.athlete.email }}
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex flex-column align-items-start">
                                        <div
                                            class="badge"
                                            [ngClass]="{
                                                'badge-success': isMembershipActive(row),
                                                'badge-error': !isMembershipActive(row)
                                            }"
                                        >
                                            {{ membershipLabel(row) }}
                                        </div>
                                        <div
                                            *ngIf="membershipExpiryLabel(row) as expiry"
                                            class="small text-muted mt-1"
                                        >
                                            Scade il {{ expiry }}
                                        </div>
                                    </div>
                                </td>
                                <td *ngIf="primaryDocumentExists">
                                    <div class="d-flex flex-column align-items-start">
                                        <div
                                            class="badge w-100"
                                            [ngClass]="
                                                utils.remaningDays(row.athlete.primaryDocExpirationDate).status === 'success'
                                                    ? 'badge-success'
                                                    : utils.remaningDays(row.athlete.primaryDocExpirationDate).status === 'danger'
                                                      ? 'badge-error'
                                                      : utils.remaningDays(row.athlete.primaryDocExpirationDate).status === 'warning'
                                                        ? 'badge-warning'
                                                        : 'badge-unknown'
                                            "
                                        >
                                            {{ utils.remaningDays(row.athlete.primaryDocExpirationDate).text }}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </ui-table>

                    <p
                        *ngIf="form.categoryId && invitedUsers.length === 0"
                        class="!mb-0 !mt-3 !text-sm !text-subtle"
                    >
                        Seleziona gli atleti da convocare usando le caselle nella tabella.
                    </p>
                </section>
            </form>
        </div>

        <footer class="!flex !items-center !justify-end !gap-3 !border-t !border-border !px-5 !py-4">
            <button
                type="button"
                class="btn welldone-btn-gray"
                (click)="onClose()"
            >
                Annulla
            </button>
            <button
                type="button"
                class="btn btn-primary"
                [disabled]="saveInProgress || !form.title || !form.status || !form.date || !form.location || !form.address || !form.city || !form.categoryId"
                (click)="onSave()"
            >
                {{ isEditMode ? 'Salva modifiche' : 'Crea convocazione' }}
            </button>
        </footer>
    </div>
</div>
